import { render, staticRenderFns } from "./WinloseElasticBody.vue?vue&type=template&id=32418162&scoped=true&"
import script from "./WinloseElasticBody.vue?vue&type=script&lang=ts&"
export * from "./WinloseElasticBody.vue?vue&type=script&lang=ts&"
import style0 from "./WinloseElasticBody.vue?vue&type=style&index=0&id=32418162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32418162",
  null
  
)

export default component.exports